import React, { Component } from 'react';
import { Button, Tabs, Row, Col, Modal, Icon, Input, message, Form, Table, LocaleProvider, Select, DatePicker, Radio } from 'antd';
import EventSet from "./../../../../../assets/PubJs/hcPub";//公用的所有事件
import { Hcurl } from "./../../../../../constants/index";//获取公共路径
import Event from "./../../../../../assets/PubJs/hcPub"//所有事件
import $ from "jquery";
import createHistory from 'history/createHashHistory';//路由切换地址
import zhCN from 'antd/lib/locale-provider/zh_CN';
import "./../style.css"
const history = createHistory();//定义history路由
const FormItem = Form.Item;
const RadioGroup = Radio.Group;

var _companysModal = null;
class CompanysModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: this.props.visible,
            list: [],
            value: Event.getUserInfo().xxhjcompanycode,
            confirmLoading: false
        }
    }
    componentDidMount() {
        _companysModal = this;
        this.GetSelectCompany();
    }
    componentWillReceiveProps = (props) => {
        //console.log(props, 'props');
        
        if (props.visible == true) {
            this.setState({
                visible: true
            })
            this.GetSelectCompany();
        }
    }
    addCompany = () => {
        let setData = {
            UserCode: Event.getUserInfo().CU_Code,
            CompanyCode: _companysModal.state.value,
            Type: "0",
        };
        $.ajax({
            url: Hcurl + "/CompanyCore/ChangeCompany",
            type: "post",
            data: setData,
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                console.log(res, 'res');
                if (res.split("|")[0] == "false") {
                    message.error(res.split("|")[1]);
                    _companysModal.setState({
                        confirmLoading: false,
                    });
                } else {
                    message.success('提交成功');
                    _companysModal.props.setDefaultCom(res.split("|")[2], _companysModal.state.visible, _companysModal.state.value);
                    let userInfo = JSON.parse(localStorage.userInfo);
                    userInfo.xxhjcompanycode = res.split("|")[1];
                    userInfo.XXHJCom_Name = res.split("|")[2];
                    userInfo.UCR_IsAdmin = res.split("|")[3];
                    localStorage.setItem("userInfo", JSON.stringify(userInfo));
                    console.log(JSON.parse(localStorage.getItem('userInfo')), '213');
                    _companysModal.setState({
                        confirmLoading: false,
                    });
                }
            },
            error: function (data, err) {
                _companysModal.setState({
                    confirmLoading: false,
                });
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    }
    handleOk = () => {
        this.setState({
            confirmLoading: true,
            visible: false,
        })
        setTimeout(() => {
            _companysModal.addCompany();
        }, 20)
    }
    handleCancel = () => {
        this.setState({
            visible: false
        })
        setTimeout(() => {
            _companysModal.props.setDefaultCom('value', _companysModal.state.visible);
        }, 20)
    }
    GetSelectCompany = () => {
        let setData = {
            UserCode: Event.getUserInfo().CU_Code,
        };
        $.ajax({
            url: Hcurl + "/CompanyCore/GetSelectCompany",
            type: "post",
            data: setData,
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                res = JSON.parse(res)
                console.log(res, 'res');
                _companysModal.setState({
                    list: res
                })
                if (res.length == 1) {
                    _companysModal.props.isShow(res)
                }
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    }
    onRadioChange = (e) => {
        console.log(e, 'e');
        this.setState({
            value: e.target.value,
        });
    };
    render() {
        return (
            <div>
                <Modal
                    visible={this.state.visible}
                    title='切换企业'
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    confirmLoading={this.state.confirmLoading}
                >
                    <div className={"CompanyModal_radioGroupList"}>
                        <p>单击下方企业名称进行切换</p>
                        <RadioGroup onChange={this.onRadioChange} value={this.state.value}>
                            {
                                this.state.list.map(function (e) {
                                    return <Radio key={e.Com_CreditCode} value={e.Com_CreditCode} > {e.Com_Name}</Radio>
                                })
                            }
                        </RadioGroup>
                    </div>
                </Modal>
            </div>

        )
    }
}


export default CompanysModal;


// WEBPACK FOOTER //
// ./src/components/Content/Business/CompanyAccord/CompanyRegistration/CompanyModal.js